import _ from 'lodash';

import { PATH } from '../../constants/path';

export const convertPartnerNameForUrl = name => _.kebabCase(_.deburr(name));

/**
 * Retourne l'url vers la fiche d'un partenaire
 * @param {JSON} contient le nom du partenaire à inclure dans l'url et son id
 */
export function getMerchantCardUrl({ id, name }, isOffline, isEbon) {
    const path = isOffline
        ? PATH.MERCHANTPAGE_OFFLINE_PATH
        : isEbon
        ? PATH.MERCHANTPAGE_EBON_PATH
        : PATH.MERCHANTPAGE_ONLINE_PATH;
    return name && id ? `${path}${convertPartnerNameForUrl(name)}-${id}` : '';
}

/**
 * Retourne l'url vers l'instertitiel cashback
 * TODO: à bouger dans la future feature interstitiel. Créer un utils avec toutes les fonctions pour créer des urls d'interstitiels
 */
export function getInstertitielCashbackUrl({ id }) {
    return id ? `${PATH.INTERSTITIEL_CASHBACK_PATH}${id}/0` : '';
}

export const displayableCashback = (percent, fixed) => {
    const cashback = [];
    percent && cashback.push(`${percent}%`);
    fixed && cashback.push(`${fixed}€`);
    return `${cashback.join(' + ').replace(/[.]/g, ',')}`;
};

export const displayableCashbackComplete = (
    partner = null,
    partnerI18n = null,
    isOffline = false,
    isEbon = false
) => {
    if (_.isEmpty(partner) || _.isEmpty(partnerI18n)) {
        return '';
    }

    if (isEbon && hasEbon(partner) && hasEbonCashback(partner)) {
        let content = '';
        const ebonDiscount = partner.ebonDiscount.cashback;

        if (partner && partner.discountCount > 0) {
            content += `${partnerI18n.jusqua} `;
        }
        content += `${displayableCashback(
            ebonDiscount.percent.value,
            ebonDiscount.fixed.value
        )} ${renderPluralConditional(
            partnerI18n.rembourse,
            () => partner && (ebonDiscount.fixed.value > 1 || ebonDiscount.percent.value > 1)
        )} `;
        if (ebonDiscount.percent.initialValue || ebonDiscount.fixed.initialValue) {
            content += `${partnerI18n.aulieude} `;
            content += `${displayableCashback(
                ebonDiscount.percent.initialValue,
                ebonDiscount.fixed.initialValue
            )}`;
        }
        return content;
    }

    if (hasCashback(partner) || hasCashbackOffline(partner)) {
        let content = '';
        let discount =
            !hasCashback(partner) || isOffline
                ? partner.mostDisplayableDiscountOffline
                : partner.mostDisplayableDiscountOnline;

        if (discount) {
            if (partner && partner.isMultiDiscount) {
                content += `${partnerI18n.jusqua} `;
            }
            content += `${displayableCashback(
                discount.percent,
                discount.fixed
            )} ${renderPluralConditional(
                partnerI18n.rembourse,
                () => partner && (discount.fixed > 1 || discount.percent > 1)
            )} `;
            if (discount.initialPercent || discount.initialFixed) {
                content += `${partnerI18n.aulieude} `;
                content += `${displayableCashback(discount.initialPercent, discount.initialFixed)}`;
            }
            return content;
        } else {
            return partnerI18n.pasdecashbackencemoment;
        }
    } else {
        return partnerI18n.pasdecashbackencemoment;
    }
};

export const renderPluralConditional = (str, condition) => {
    return str && condition && condition() ? str + 's' : str;
};

export const hasCashback = partner =>
    partner &&
    partner.mostDisplayableDiscountOnline &&
    (partner.mostDisplayableDiscountOnline.fixed > 0 ||
        partner.mostDisplayableDiscountOnline.percent > 0);

export const hasCashbackOffline = partner =>
    partner &&
    !!partner.mostDisplayableDiscountOffline &&
    (partner.mostDisplayableDiscountOffline.fixed > 0 ||
        partner.mostDisplayableDiscountOffline.percent > 0);

export const hasEbonCashback = ebonPartner => {
    if (ebonPartner && ebonPartner.ebonDiscount && ebonPartner.ebonDiscount.cashback) {
        const ebonDiscount = ebonPartner.ebonDiscount.cashback;
        return ebonDiscount.fixed.value > 0 || ebonDiscount.percent.value > 0;
    }
    return false;
};

export const hasCoupon = partner => partner && partner.couponCount > 0;

export const hasEbon = partner => partner && partner.ebonDiscount;

export const hasOffline = partner => partner && partner.hasOffline;

export const isMultiDiscount = partner => partner && partner.isMultiDiscount;

export const isMultiDiscountOffline = partner => partner && partner.isMultiDiscountOffline;

export const hasOnAndOffCashback = partner =>
    hasCashback(partner) && hasOffline(partner) && hasCashbackOffline(partner);



// WEBPACK FOOTER //
// ./src/services/partner/utils.js